import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'existItemInList',
})
export class ExistItemInListPipe implements PipeTransform {
  transform(list: any[], value: any, key: string = ''): boolean {
    if (!list) return false;
    const idx = key
      ? list.findIndex((item) => item[key] === value)
      : list.findIndex((item) => item === value);
    return idx !== -1;
  }
}
